import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import { computed, ref } from 'vue';
import ExpansionCard from '~/components/Collections/ExpansionCard.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PurchaseMyTheaterInstructions',
  setup(__props) {

const { i18n } = useContext();
const items: { title: string; description: string }[] = [];
for (let i = 0; i < 3; i++) {
  items.push({
    title: i18n.t(
      `components.myTheater.purchaseInstructions.steps[${i}].title`,
    ),
    description: i18n.t(
      `components.myTheater.purchaseInstructions.steps[${i}].description`,
    ),
  });
}

return { __sfc: true,i18n, items, ExpansionCard }
}

})